export default "__VITE_ASSET__Clg_wEny__"